module.exports = __webpack_public_path__ + "static/media/experience-home-comforts.887dd9f6.jpg";